module.exports = __webpack_public_path__ + "img/slider_home_01.522f4ddd.jpg";